

// // src/components/admin/AdminSidebar.jsx
// import React from 'react';
// import { NavLink, useNavigate, Link } from 'react-router-dom';
// import { 
//   FaTachometerAlt, 
//   FaCogs, 
//   FaProjectDiagram, 
//   FaImages, 
//   FaCertificate,
//   FaCog,
//   FaSignOutAlt,
//   FaBuilding
// } from 'react-icons/fa';
// import { useAuth } from '../../context/AuthContext';

// const AdminSidebar = () => {
//   const { signOut } = useAuth();
//   const navigate = useNavigate();

//   const navItems = [
//     { icon: FaTachometerAlt, label: 'Dashboard', path: '/admin' },
//     { icon: FaCogs, label: 'Services', path: '/admin/services' },
//     { icon: FaProjectDiagram, label: 'Projects', path: '/admin/projects' },
//     { icon: FaImages, label: 'Media', path: '/admin/media' },
//     { icon: FaCertificate, label: 'Certifications', path: '/admin/certifications' },
//     { icon: FaCog, label: 'Settings', path: '/admin/settings' },
//   ];

//   const handleLogout = () => {
//     signOut();
//     navigate('/');
//   };

//   return (
//     <div className="w-64 bg-gray-900 min-h-screen text-white">
//       {/* Logo with company logo */}
//       <div className="p-6 border-b border-gray-800">
//         <Link to="/admin" className="flex items-center space-x-3">
//           {/* Company Logo - same as in user navbar */}
//           <img 
//             src="/company_logo.jpg" // Same path as user navbar
//             alt="Brasotech Investments Logo"
//             className="h-10 w-auto" // Adjust height as needed
//             onError={(e) => {
//               e.target.onerror = null; // Prevent infinite loop
//               // Fallback to icon if logo fails to load
//               e.target.style.display = 'none';
//               const parent = e.target.parentElement;
//               if (parent) {
//                 const fallback = document.createElement('div');
//                 fallback.className = 'h-10 w-10 bg-gradient-to-r from-blue-600 to-blue-800 rounded-lg flex items-center justify-center text-white font-bold text-sm';
//                 fallback.textContent = 'BI';
//                 parent.insertBefore(fallback, parent.firstChild);
//               }
//             }}
//           />
//           <div>
//             <h1 className="text-xl font-bold">Brasotech</h1>
//             <p className="text-xs text-gray-400">Admin Panel</p>
//             <span className="text-xs text-blue-400 block mt-1">Investments Limited</span>
//           </div>
//         </Link>
        
//         {/* Optional: Add link back to main site */}
//         <Link 
//           to="/" 
//           className="mt-3 text-xs text-gray-400 hover:text-white transition-colors flex items-center"
//         >
//           <span className="mr-1">←</span> Back to Main Site
//         </Link>
//       </div>

//       {/* Navigation */}
//       <nav className="p-4">
//         <ul className="space-y-2">
//           {navItems.map((item) => (
//             <li key={item.path}>
//               <NavLink
//                 to={item.path}
//                 className={({ isActive }) =>
//                   `flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
//                     isActive
//                       ? 'bg-blue-600 text-white'
//                       : 'text-gray-300 hover:bg-gray-800 hover:text-white'
//                   }`
//                 }
//               >
//                 <item.icon className="h-5 w-5" />
//                 <span className="font-medium">{item.label}</span>
//               </NavLink>
//             </li>
//           ))}
//         </ul>
//       </nav>

//       {/* Logout */}
//       <div className="absolute bottom-0 w-64 p-4 border-t border-gray-800">
//         <button
//           onClick={handleLogout}
//           className="flex items-center space-x-3 w-full px-4 py-3 text-gray-300 hover:bg-gray-800 hover:text-white rounded-lg transition-colors"
//         >
//           <FaSignOutAlt className="h-5 w-5" />
//           <span className="font-medium">Logout</span>
//         </button>
        
//         {/* Optional: Display current user info */}
//         <div className="mt-3 pt-3 border-t border-gray-700 text-xs text-gray-400">
//           <p>Admin Dashboard v1.0</p>
//           <p className="mt-1">© {new Date().getFullYear()} Brasotech</p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminSidebar;




// src/components/admin/AdminSidebar.jsx
import React from 'react';
import { NavLink, useNavigate, Link } from 'react-router-dom';
import { 
  FaTachometerAlt, 
  FaCogs, 
  FaProjectDiagram, 
  FaImages, 
  FaCertificate,
  FaCog,
  FaSignOutAlt,
  FaBuilding,
  FaUsers,
  FaUserShield,
  FaUserCog,
  FaChartBar,
  FaShieldAlt
} from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';

const AdminSidebar = () => {
  const { signOut, user, isSuperAdmin, hasPermission } = useAuth();
  const navigate = useNavigate();

  // Base navigation items for all admins
  const navItems = [
    { 
      icon: FaTachometerAlt, 
      label: 'Dashboard', 
      path: '/admin',
      permission: null
    },
    { 
      icon: FaCogs, 
      label: 'Services', 
      path: '/admin/services',
      permission: 'manage_services'
    },
    { 
      icon: FaProjectDiagram, 
      label: 'Projects', 
      path: '/admin/projects',
      permission: 'manage_projects'
    },
    { 
      icon: FaImages, 
      label: 'Media', 
      path: '/admin/media',
      permission: 'manage_media'
    },
    { 
      icon: FaCertificate, 
      label: 'Certifications', 
      path: '/admin/certifications',
      permission: 'manage_certificates'
    },
    { 
      icon: FaChartBar, 
      label: 'Analytics', 
      path: '/admin/analytics',
      permission: 'view_analytics'
    },
    { 
      icon: FaCog, 
      label: 'Settings', 
      path: '/admin/settings',
      permission: 'manage_settings'
    },
  ];

  // User management section
  const userManagementItems = [
    { 
      icon: FaUsers, 
      label: 'All Users', 
      path: '/admin/users',
      permission: 'manage_users',
      showForSuperAdmin: true
    },
    { 
      icon: FaUserCog, 
      label: 'User Management', 
      path: '/admin/user-management',
      permission: 'manage_users',
      showForSuperAdmin: true
    },

    { 
      icon: FaUserCog, 
      label: 'AI Settings', 
      path: '/admin/ai-settings',
      permission: 'manage_users',
      showForSuperAdmin: true
    },
  ];

  // Super admin only items
  const superAdminItems = [
    { 
      icon: FaUserShield, 
      label: 'Admin Management', 
      path: '/admin/admin-management',
      permission: 'manage_users',
      showForSuperAdmin: true
    },
    { 
      icon: FaShieldAlt, 
      label: 'System Settings', 
      path: '/admin/system-settings',
      permission: 'manage_settings',
      showForSuperAdmin: true
    },
  ];

  const handleLogout = () => {
    signOut();
    navigate('/');
  };

  const shouldShowItem = (item) => {
    if (isSuperAdmin) return true;
    if (!item.permission) return true;
    return hasPermission(item.permission);
  };

  return (
    <div className="w-64 bg-gray-900 min-h-screen text-white flex flex-col">
      {/* Logo with company logo */}
      <div className="p-4 border-b border-gray-800">
        <Link to="/admin" className="flex items-center space-x-3">
          <img 
            src="/company_logo.jpg"
            alt="Brasotech Investments Logo"
            className="h-8 w-8 rounded-lg"
            onError={(e) => {
              e.target.onerror = null;
              e.target.style.display = 'none';
              const parent = e.target.parentElement;
              if (parent) {
                const fallback = document.createElement('div');
                fallback.className = 'h-8 w-8 bg-gradient-to-r from-blue-600 to-blue-800 rounded-lg flex items-center justify-center text-white font-bold text-xs';
                fallback.textContent = 'BI';
                parent.insertBefore(fallback, parent.firstChild);
              }
            }}
          />
          <div className="min-w-0">
            <h1 className="text-lg font-bold truncate">Brasotech</h1>
            <p className="text-xs text-gray-400 truncate">Admin Panel</p>
          </div>
        </Link>
        
        {/* Current user info */}
        <div className="mt-4 p-3 bg-gray-800 rounded-lg">
          <div className="flex items-center space-x-3">
            <div className={`h-8 w-8 flex-shrink-0 rounded-full flex items-center justify-center ${
              user?.role === 'super_admin' ? 'bg-purple-600' : 'bg-blue-600'
            }`}>
              <span className="text-xs font-bold">
                {user?.name?.charAt(0)?.toUpperCase() || 'A'}
              </span>
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium truncate">{user?.name || 'Admin'}</p>
              <p className="text-xs text-gray-400 truncate">{user?.role || 'Admin'}</p>
            </div>
          </div>
        </div>

        <Link 
          to="/" 
          className="mt-3 text-xs text-gray-400 hover:text-white transition-colors flex items-center truncate"
        >
          <span className="mr-1">←</span> Back to Main Site
        </Link>
      </div>

      {/* Navigation - Scrollable area */}
      <nav className="flex-1 p-4 space-y-6 overflow-y-auto">
        {/* Main Navigation Section */}
        <div>
          <h3 className="text-xs uppercase tracking-wider text-gray-400 font-semibold px-3 mb-2 truncate">
            Main
          </h3>
          <ul className="space-y-1">
            {navItems.filter(shouldShowItem).map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `flex items-center px-3 py-2.5 rounded-lg transition-colors ${
                      isActive
                        ? 'bg-blue-600 text-white'
                        : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                    }`
                  }
                >
                  <item.icon className="h-4 w-4 flex-shrink-0" />
                  <span className="ml-3 text-sm font-medium truncate flex-1">{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>

        {/* User Management Section */}
        {userManagementItems.some(shouldShowItem) && (
          <div>
            <h3 className="text-xs uppercase tracking-wider text-gray-400 font-semibold px-3 mb-2 truncate">
              User Management
            </h3>
            <ul className="space-y-1">
              {userManagementItems.filter(shouldShowItem).map((item) => (
                <li key={item.path}>
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `flex items-center px-3 py-2.5 rounded-lg transition-colors ${
                        isActive
                          ? 'bg-green-600 text-white'
                          : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                      }`
                    }
                  >
                    <item.icon className="h-4 w-4 flex-shrink-0" />
                    <span className="ml-3 text-sm font-medium truncate flex-1">{item.label}</span>
                    {item.showForSuperAdmin && isSuperAdmin && (
                      <span className="ml-2 text-xs bg-purple-600 px-1.5 py-0.5 rounded flex-shrink-0">
                        Super
                      </span>
                    )}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Super Admin Section */}
        {isSuperAdmin && superAdminItems.length > 0 && (
          <div>
            <h3 className="text-xs uppercase tracking-wider text-gray-400 font-semibold px-3 mb-2 truncate">
              Super Admin
            </h3>
            <ul className="space-y-1">
              {superAdminItems.map((item) => (
                <li key={item.path}>
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `flex items-center px-3 py-2.5 rounded-lg transition-colors ${
                        isActive
                          ? 'bg-purple-600 text-white'
                          : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                      }`
                    }
                  >
                    <item.icon className="h-4 w-4 flex-shrink-0" />
                    <span className="ml-3 text-sm font-medium truncate flex-1">{item.label}</span>
                    <span className="ml-2 text-xs bg-purple-600 px-1.5 py-0.5 rounded flex-shrink-0">
                      Super
                    </span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Quick Stats */}
        <div className="mt-6 px-3">
          <div className="p-3 bg-gray-800 rounded-lg">
            <p className="text-xs text-gray-400 mb-1 truncate">System Status</p>
            <div className="flex items-center space-x-2">
              <div className="h-2 w-2 bg-green-500 rounded-full animate-pulse flex-shrink-0"></div>
              <span className="text-xs text-green-400 truncate">All Systems Operational</span>
            </div>
          </div>
        </div>
      </nav>

      {/* Logout - Fixed at bottom */}
      <div className="border-t border-gray-800 p-4 mt-auto">
        <button
          onClick={handleLogout}
          className="flex items-center space-x-3 w-full px-3 py-2.5 text-gray-300 hover:bg-red-900/20 hover:text-red-300 rounded-lg transition-colors group"
        >
          <FaSignOutAlt className="h-4 w-4 flex-shrink-0 group-hover:text-red-400" />
          <span className="text-sm font-medium group-hover:text-red-400 truncate">Logout</span>
        </button>
        
        <div className="mt-3 pt-3 border-t border-gray-700 text-xs text-gray-400">
          <div className="flex justify-between items-center mb-1 truncate">
            <p className="truncate">Dashboard v1.0</p>
            <span className={`px-2 py-1 rounded text-xs flex-shrink-0 ${
              user?.role === 'super_admin' 
                ? 'bg-purple-900 text-purple-300' 
                : 'bg-blue-900 text-blue-300'
            }`}>
              {user?.role || 'admin'}
            </span>
          </div>
          <p className="mt-1 truncate">© {new Date().getFullYear()} Brasotech</p>
        </div>
      </div>
    </div>
  );
};

export default AdminSidebar;